<template>
  <div
    :class="{ 'pt-smh': $root.siteMessageIsVisible }"
    class="fixed inset-0 z-50"
  >
    <div
      class="flex flex-col h-full bg-paint px-ogs-large overflow-x-hidden overflow-y-scroll scrolling-touch pb-10"
    >
      <div class="flex-shrink-0 h-shh flex items-center relative z-10">
        <button
          class="block w-12 focus:outline-none text-theme"
          @click="$emit('close')"
        >
          <IconArrowLeftAlt />
        </button>
      </div>
      <div class="flex-1 py-6 relative z-0">
        <h2 v-if="heading" class="text-lg text-theme mb-8">{{ heading }}</h2>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import IconArrowLeftAlt from "../../../templates/_includes/svg/icon-arrow-left-alt.svg";

export default {
  name: "SiteMenuFlyoutLayout",

  components: {
    IconArrowLeftAlt,
  },

  props: {
    heading: {
      type: String,
      default: "",
    },
  },
};
</script>
